import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";
import { advisorApi, advisorToken } from "@/lib/advisorApi";
import { AdvisorAuthShell, AuthFooterLink } from "@/components/asesor/AdvisorAuthShell";

const MIN = 10;

export default function AdvisorSetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (pw.length < MIN) { setError(`La contraseña debe tener al menos ${MIN} caracteres.`); return; }
    if (pw !== pw2) { setError("Las contraseñas no coinciden."); return; }
    setSaving(true);
    setError("");
    try {
      await advisorApi.post("/asesor/auth/set-password", { token, password: pw });
      advisorToken.clear();
      toast.success("Contraseña guardada. Ya puedes entrar.");
      nav("/asesor/login", { replace: true });
    } catch (err) { setError(formatApiError(err)); }
    finally { setSaving(false); }
  }

  if (!token) {
    return (
      <AdvisorAuthShell title="Enlace no válido" subtitle="Abre el enlace completo que te llegó por correo." testId="page-asesor-set-password">
        <AuthFooterLink to="/asesor/olvide-contrasena" testId="asesor-request-new">Pedir un enlace nuevo</AuthFooterLink>
      </AdvisorAuthShell>
    );
  }

  return (
    <AdvisorAuthShell title="Define tu contraseña" subtitle={`Mínimo ${MIN} caracteres. Solo tú la conoces.`} testId="page-asesor-set-password">
      <form onSubmit={onSubmit} className="space-y-4" data-testid="asesor-set-password-form">
        <div><Label className="field-label">Nueva contraseña</Label><Input type="password" required autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="asesor-new-password" /></div>
        <div><Label className="field-label">Confirmar contraseña</Label><Input type="password" required autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="asesor-confirm-password" /></div>
        {error && <p className="rounded-sm bg-red-50 p-3 text-xs text-red-700" data-testid="asesor-set-password-error">{error}</p>}
        <button type="submit" disabled={saving} className="btn-primary w-full disabled:opacity-60" data-testid="asesor-set-password-submit">
          {saving ? "Guardando..." : "Guardar contraseña"}
        </button>
      </form>
      <AuthFooterLink to="/asesor/login" testId="asesor-back-login">Ir a iniciar sesión</AuthFooterLink>
    </AdvisorAuthShell>
  );
}
